export default __webpack_public_path__ + "static/media/Hair_19_F_C4.4a696b25.svg";